import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  createStyles,
  makeStyles,
} from "@material-ui/core";

interface props {
  isOpen: boolean;
  title?: string;
  text?: string;
  textConfirm?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const useClasses = makeStyles((theme) =>
  createStyles({
    root: {
      "& .MuiPaper-root": {
        padding: "0px 10px 10px 10px",
        maxWidth: "400px",
      },
    },
  })
);

const useButtonClasses = makeStyles((theme) =>
  createStyles({
    root: {
      height: 50,
      width: 200,
      "&.error": {
        backgroundColor: "#FFEEEE",
        color: theme.palette.error.main,
        "&:hover": {
          backgroundColor: "#FFBFBF",
          color: theme.palette.error.dark,
        },
      },
    },
  })
);

const ConfirmDialog = ({
  isOpen,
  title,
  text,
  textConfirm,
  onConfirm,
  onCancel,
}: props) => {
  const classes = useClasses();
  const buttonClasses = useButtonClasses();

  return (
    <Dialog open={isOpen} className={classes.root} onClose={onCancel}>
      <DialogTitle>
        <div>
          <Typography
            variant="h5"
            align="center"
            style={{ fontWeight: "bold" }}
          >
            {title || "Confirmar"}
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <div>
          <Typography variant="subtitle1" align="center">
            {text || "Esta séguro de confirmar los cambios"}
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className={`error ${buttonClasses.root}`}
          variant="contained"
          size="large"
          fullWidth
          onClick={onCancel}
        >
          Cancelar
        </Button>
        <Button
          className={buttonClasses.root}
          variant="contained"
          size="large"
          fullWidth
          onClick={onConfirm}
        >
          {textConfirm || "Confirmar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
